// Explicit preview fixtures only. Never derives facts from a selected file.
export function passportDemoResult(scenario: string | null, attempt = 0): { state: string; fields: Record<string, string> } | null {
  if (scenario === "failure" && attempt === 0) return { state: "failed", fields: {} };
  if (scenario === "correction" && attempt === 0) return { state: "correction", fields: {} };
  if (!scenario || !["success", "conflict", "missing", "failure", "correction"].includes(scenario)) return null;
  const fields: Record<string, string> = {
    "pf.identity.nationalities": "CO",
    "pf.passport.issuing_country": "CO",
    "pf.passport.number": "DEMO123456",
    "pf.passport.issue_date": "2026-10-01",
    "pf.passport.expiry_date": "2036-10-01",
    "pf.identity.given_names": "Alex",
    "pf.identity.family_primary": "Morgan",
    "pf.identity.birth_date": "1990-04-15",
    "pf.identity.birth_city": "Bogota",
    "pf.identity.birth_country": "CO",
    "pf.identity.sex_as_documented": "M",
  };
  if (scenario === "conflict") fields["pf.identity.given_names"] = "Alexander";
  if (scenario === "missing") delete fields["pf.identity.birth_city"];
  return { state: "review", fields };
}

export function passportDifferences(existing: Record<string, unknown>, extracted: Record<string, string>): string[] {
  return Object.keys(extracted).filter(
    (key) => existing[key] != null && String(existing[key]).trim() && String(existing[key]) !== String(extracted[key]),
  );
}

export function mergePassportReview(
  existing: Record<string, unknown>,
  extracted: Record<string, string>,
  choices: Record<string, string>,
): Record<string, unknown> | null {
  const differences = passportDifferences(existing, extracted);
  if (differences.some((key) => !["existing", "passport"].includes(choices[key]))) return null;
  return {
    ...existing,
    ...Object.fromEntries(Object.entries(extracted).filter(([key]) => choices[key] !== "existing")),
  };
}
